module.exports = __webpack_public_path__ + "static/media/ic_dropcalendario.61049baa.svg";